<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <div>
      <div>
        <b-row>
          <b-col cols="11" style="text-align: left">
            <p class="m-0" style="font-size: 1.1em; color: #063553; font-weight: 600">
              {{ empresaActual.nombrePlan }}
            </p>
            <div>
              <p class="m-0" style="color: #063553;">Vigencia: {{ empresaActual.fechaInicio | formatoFecha }} al {{ empresaActual.fechaFin | formatoFecha }}</p>
            </div>
          </b-col>

          <b-col
              cols="1"
              style="font-size: 16px; text-align: right; !important"
              class="pl-3 pr-2"
          >
            <p v-if="empresaActual.registroActivo && empresaActual.estatus && !empresaActual.suspendido" style="text-align: right; background-color: #DBFFD8; color: #1E7C1E; width: max-content; padding: 1% 4%; margin-top: 1%; font-size: 0.85em; font-weight: 600; border-radius: 20px;">
              <span>Activo</span>
            </p>
            <p v-if="!empresaActual.estatus && !empresaActual.suspendido" style="text-align: right; background-color: #efb3b3; color: #950000; width: max-content; padding: 1% 4%; margin-top: 1%; font-size: 0.85em; font-weight: 600; border-radius: 20px;">
              <span>Inactivo</span>
            </p>
            <p v-if="empresaActual.suspendido" style="text-align: right; background-color: #efb3b3; color: #950000; width: max-content; padding: 1% 4%; margin-top: 1%; font-size: 0.85em; font-weight: 600; border-radius: 20px;">
              <span>Suspendido</span>
            </p>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-start mt-4 mb-3 w-100">
          <div v-for="(tab, index) in tabs" v-bind:key="index">
            <div
                class="d-flex justify-content-center flex-column mr-5 pt-2"
                :class="activeTabIndex == index ? 'selected-tab' : 'default-tab'"
                @click="activeTabIndex = index"
                style="min-width: max-content"
            >
              <p
                  class="m-0 text-center"
                  :class="activeTabIndex == index ? '' : 'mb-2'"
              >
                {{ tab.title }}
              </p>
              <hr
                  v-if="activeTabIndex == index"
                  class="w-50 mx-auto m-0 p-0 mt-2"
                  style="height: 0.08em; background-color: #83bee8"
              />
            </div>
          </div>
        </div>

        <div v-if="activeTabIndex == 0">
          <b-row>
            <b-col style="border-right: 2px solid #ececec">
              <div
                  class="scrollable-container-catalogo no-horizontal-scroll pt-4"
                  style="min-height: 25em"
              >
                <h6 class="mb-3" style="color: #357D97; font-weight: 600;">
                  Descripción del plan
                </h6>
                <b-card-text style="text-align: left">
                  <span v-html="empresaActual.descripcion"></span>
                </b-card-text>
              </div>
            </b-col>
            <b-col>
              <div
                  class="scrollable-container-catalogo no-horizontal-scroll pt-4"
                  style="min-height: 25em"
              >
                <h6 class="mb-3" style="color: #357D97; font-weight: 600;">
                  Requisitos
                </h6>
                <b-card-text style="text-align: left">
                  <span v-html="empresaActual.requisitos"></span>
                </b-card-text>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-if="activeTabIndex == 1">
          <b-row>
            <b-col class="pt-4" style="border-right: 1px solid #ECECEC;">
              <h6 class="mb-3" style="color: #357D97; font-weight: 600;">
                Tratamientos y descuentos
              </h6>
              <div class="scrollable-container-catalogo no-horizontal-scroll">
                <label>Búsqueda: </label>
                <v-select
                    label="tratamiento"
                    id="idTratamiento"
                    v-model="tratamientoDescuentoBuscado"
                    :options="lstTratamientosDescuento"
                    @input="seleccionarBusquedatratamiento($event)"
                >
                  <template #option="{ tratamiento }">
                    <label>{{ tratamiento }}</label>
                  </template>
                  <span slot="no-options">No hay datos...</span>
                </v-select>
                <br />
                <b-card-text>
                  <div style="text-align: left">
                    <b-list-group class="overflow-auto" flush>
                      <b-list-group-item
                          v-for="(
                                tratamiento, index
                              ) of datosTablalstTratamientosDescuento"
                          :key="index"
                      >
                        {{ tratamiento.descuento }}% -
                        {{ tratamiento.tratamiento }}
                        <strong style="font-size: 13px">{{
                            tratamiento.descuentoEspecial != null &&
                            tratamiento.descuentoEspecial > 0
                                ? " Descuento especial: " +
                                tratamiento.descuentoEspecial +
                                "%" +
                                " (" +
                                (tratamiento.vecesAnio != null
                                    ? tratamiento.vecesAnio
                                    : 1) +
                                " al año)"
                                : ""
                          }}</strong>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                  <div
                      style="text-align: center"
                      v-if="loaderTratamientos"
                  >
                    <b-spinner
                        variant="primary"
                        label="Spinning"
                    ></b-spinner>
                  </div>
                  <div style="text-align: center" v-if="blnTratamientos">
                    <b-alert show variant="warning"
                    >No se encontraron datos</b-alert
                    >
                  </div>
                </b-card-text>
              </div>
            </b-col>
            <b-col>
              <div class="pt-4">
                <h6 class="mb-3" style="color: #357D97; font-weight: 600;">
                  Grupos de tratamientos
                </h6>
                <div class="scrollable-container-catalogo no-horizontal-scroll">
                  <label>Búsqueda: </label>
                  <v-select
                      label="nombreTratamiento"
                      id="idTratamiento"
                      v-model="tratamientoDescuentoGrupoBuscado"
                      :options="lstTratamientosDescuentoGrupo"
                      @input="seleccionarBusquedaGrupotratamiento($event)"
                  >
                    <template #option="{ nombreTratamiento }">
                      <label>{{ nombreTratamiento }}</label>
                    </template>
                    <span slot="no-options">No hay datos...</span>
                  </v-select>
                  <br />

                  <b-card-text>
                    <div style="text-align: left">
                      <b-list-group class="overflow-auto" flush>
                        <b-list-group-item
                            v-for="(
                                grupos, index
                              ) of datosTablalstTratamientosGrupoDescuento"
                            :key="index"
                        >
                          <div>
                            {{ grupos.descuento }}% -
                            {{ grupos.descripcion }}
                            <strong style="font-size: 13px">{{
                                grupos.precioEspecial != null &&
                                grupos.precioEspecial > 0
                                    ? " Descuento especial: " +
                                    grupos.precioEspecial +
                                    "%" +
                                    " (" +
                                    (grupos.vecesAnio != null
                                        ? grupos.vecesAnio
                                        : 1) +
                                    " al año)"
                                    : ""
                              }}</strong>
                          </div>
                          <div>Tratamientos:</div>
                          <b-list-group class="overflow-auto" flush>
                            <b-list-group-item
                                v-for="(
                                    grupo, indice
                                  ) of grupos.tratamientoGrupoTratamientoDTOS"
                                :key="indice"
                            >
                              <div>
                                Tratamiento: {{ grupo.nombreTratamiento }}
                              </div>
                            </b-list-group-item>
                          </b-list-group>
                        </b-list-group-item>
                        <hr />
                      </b-list-group>
                    </div>
                    <div
                        style="text-align: center"
                        v-if="loaderGrupoTratamiento"
                    >
                      <b-spinner
                          variant="primary"
                          label="Spinning"
                      ></b-spinner>
                    </div>
                    <div style="text-align: center" v-if="blnGrupos">
                      <b-alert show variant="warning"
                      >No se encontraron datos</b-alert
                      >
                    </div>
                  </b-card-text>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <!--Calculadora de precios-->
        <div v-show="activeTabIndex == 2">
          <CalculadoraPrecioTratamiento :lista-tratamientos="lstTratamientosDescuento" :lista-tratamientos-grupo="lstTratamientosDescuentoGrupo" :id-plan="Number(empresaActual.idPlan)" :es-plan-vale="vale != null"/>
        </div>
        <!--Busqueda de pacientes-->
        <div v-if="activeTabIndex == 3">
          <br>
          <div style="min-width: 350px; flex: 1;margin-right: 15px; margin-top: 0px; align-content: center"
               :style="datosPacientePlan!=null?'width: 100%;margin-left:0px;margin-top:0px':''" align="center">
            <div class="barra" style="margin: 10px; max-width: 700px">
              <div style="flex:1; display: flex;" >
                <div style="display: contents;">
                  <b-form-input
                      class="input-filter"
                      v-model="nombrePacienteBusqueda"
                      placeholder="Búsqueda de paciente por nombre o ID"
                      type="text"
                      @keydown.enter.prevent="buscarPacientes()"
                  ></b-form-input>

                  <b-button class="button-dentalia-svg-2 mr-2" variant="primary"
                            title="Ocultar buscador" style="margin: auto;"
                            @click="cancelarBuscar()"
                            v-if="datosPacientePlan!=null">
                    <em class="close_x_svg icon-dentalia-svg-2" style="height: 10px"></em>
                  </b-button>

                  <b-button size="sm"
                            v-if="datosPacientePlan == null"
                            variant="info"
                            :disabled="loadingPacientes || validarInputBusqueda()"
                            style="margin: auto;"
                            @click="buscarPacientes()">
                    <span v-if="!loadingPacientes"><em class="buscar_svg" style="height: 16px;"></em></span>
                    <span v-else><b-spinner small></b-spinner></span>
                  </b-button>
                </div>
              </div>
            </div>
            <validacion style="font-size: 10px;text-align: center;display: block;"
                        v-if="validarInputBusqueda()"
                        texto="No se pueden buscar letras y numeros al mismo tiempo" />
          </div>
          <br>
          <div class="m-4">
            <span>Búsqueda de pacientes con el plan "{{ empresaActual.nombrePlan }}"</span>
          </div>
          <br>
          <div>
            <b-table
                id="tablaPacientesPlan"
                thead-tr-class="columnasTablaSinColor"
                :items="listaPacientes"
                :fields="encabezado"
                :key="paginaActual"
                responsive="true"
                class="m-4"
                fixed>
              <template v-slot:cell(nombre)="row">
                <span @click="enviarPerfilPaciente(row.item.idPaciente)" style="cursor: pointer">
                  {{ row.item.nombre }}
                </span>
              </template>
              <template v-slot:cell(inicioVigencia)="row">
                <span>{{ row.item.inicioVigencia | formatoFecha }}</span>
              </template>
              <template v-slot:cell(finvigencia)="row">
                <span>{{ row.item.finvigencia | formatoFecha }}</span>
              </template>
              <template v-slot:cell(estatus)="row">
                <div v-if="row.item.estatus" style="background-color: #DBFFD8; color: #1E7C1E; width: max-content; padding: 1% 4%; margin-top: 1%; font-size: 0.85em; font-weight: 600; border-radius: 20px;">
                  <span>Con plan</span>
                </div>
                <div v-else>
                  <span>Inactivo</span>
                </div>
              </template>
            </b-table>
            <div align="center" v-if="loadingPacientes && busquedaRealizada" style="display: flex; justify-content: center; align-items: center; height: 50vh;">
              <b-spinner variant="info"></b-spinner>
            </div>
            <div align="center" v-else-if="!busquedaRealizada" style="display: flex; justify-content: center; align-items: center; height: 50vh;">
              <span>Haz una búsqueda para ver resultados</span>
            </div>
            <div align="center" v-else-if="busquedaRealizada && listaPacientes.length === 0" style="display: flex; justify-content: center; align-items: center; height: 50vh;">
              <span>No se encontraron resultados</span>
            </div>
            <b-pagination
                v-if="listaTotalPacientes > 20"
                align="center"
                v-model="paginaActual"
                :total-rows="listaTotalPacientes"
                :per-page="registrosPorPagina"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NuevoM2Service } from "@/apiServices/pti/NuevoM2Service";
import miniToastr from "mini-toastr";
import CalculadoraPrecioTratamiento from "@/views/PreciosTratamientos/CalculadoraPrecioTratamientos.vue";
export default {
  name: "detallePlanV2",
  components: {CalculadoraPrecioTratamiento},
  props: {
    empresaActual: null,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    tabs: [
      {title: "General"},
      {title: "Tratamientos"},
      {title: "Calculadora de precios"},
      {title: "Búsqueda de pacientes"}
    ],
    activeTabIndex: 0,
    nuevoM2Service: new NuevoM2Service(),
    blnTratamientos: false,
    blnGrupos: false,
    loaderTratamientos: false,
    loaderGrupoTratamiento: false,
    lstTratamientosDescuento: [],
    lstGruposTratamientos: [],
    datosTablalstTratamientosDescuento: [],
    datosTablalstTratamientosGrupoDescuento: [],
    tratamientoDescuentoBuscado: null,
    tratamientoDescuentoGrupoBuscado: null,
    lstTratamientosDescuentoGrupo: [],
    vale: null,

    datosPacientePlan: null,
    nombrePacienteBusqueda: null,
    mostrarBarraBusqueda: false,
    loadingPacientes: false,

    listaPacientes: [],
    listaTotalPacientes: 0,
    encabezado: [
      {key: "nombre", label:"Paciente"},
      {key: "idPaciente", label:"ID Paciente"},
      {key: "descripcionTipoAsegurado", label:"Tipo Asegurado"},
      {key: "inicioVigencia", label:"Inicio Vigencia"},
      {key: "finvigencia", label:"Fin Vigencia"},
      {key: "estatus", label:"Estatus"}
    ],
    paginaActual: 1,
    registrosPorPagina: 20,
    busquedaRealizada: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.empresaActual !== null) {
      this.empresa = this.empresaActual;
      this.obtenerTratamientosDescuentos(this.empresaActual);
      this.obtenerGrupoTratamientos(this.empresaActual);
    }
  },
  watch: {
    paginaActual() {
      this.buscarPacientes(); // Solo carga la página actual, sin tocar totalRegistros
    }
  },
  methods: {
    regresar() {
      this.$emit("regresar", "cerrar");
    },
    /**
     * Funcion para obtener los tratamientos descuentos
     * @param empresa
     */
    obtenerTratamientosDescuentos(empresa) {
      this.loaderTratamientos = true;
      const parametros = { idPlan: empresa.idPlan };
      this.$http
          .post(this.$api + "empresas/obtener/tratamientos/descuento", parametros)
          .then((response) => {
            this.loaderTratamientos = false;
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstTratamientosDescuento = [];
              this.datosTablalstTratamientosDescuento = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstTratamientosDescuento.push(item);
                this.datosTablalstTratamientosDescuento.push(item);
              });
            }
            if (this.lstTratamientosDescuento.length <= 0) {
              this.blnTratamientos = true;
            }
          })
          .catch(function (error) {
            this.loaderTratamientos = false;
            console.error(error);
          });
    },
    /**
     * Funcion para obtener los grupos de tratamietos
     * @param empresa
     */
    obtenerGrupoTratamientos(empresa) {
      this.loaderGrupoTratamiento = true;
      const parametros = { idPlan: empresa.idPlan };
      this.$http
          .post(this.$api + "empresas/obtener/grupos/tratamientos", parametros)
          .then((response) => {
            this.loaderGrupoTratamiento = false;
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstGruposTratamientos = [];
              this.datosTablalstTratamientosGrupoDescuento = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstGruposTratamientos.push(item);
                this.datosTablalstTratamientosGrupoDescuento.push(item);
              });
            }
            if (this.lstGruposTratamientos.length <= 0) {
              this.blnGrupos = true;
            }
            this.buscadorSelectGrupos();
          })
          .catch(function (error) {
            this.loaderGrupoTratamiento = false;
            console.error(error);
          });
    },

    seleccionarBusquedatratamiento(tratamiento) {
      this.datosTablalstTratamientosDescuento = [];
      if (tratamiento == null) {
        this.datosTablalstTratamientosDescuento = this.lstTratamientosDescuento;
      } else {
        this.lstTratamientosDescuento.forEach((element) => {
          if (element.idTratamiento == tratamiento.idTratamiento) {
            this.datosTablalstTratamientosDescuento.push(element);
          }
        });
      }
    },

    buscadorSelectGrupos() {
      if (this.lstGruposTratamientos.length > 0) {
        this.lstTratamientosDescuentoGrupo = [];
        this.lstGruposTratamientos.forEach((item) => {
          item.tratamientoGrupoTratamientoDTOS.forEach((datos) => {
            this.lstTratamientosDescuentoGrupo.push(datos);
          });
        });
      }
    },
    seleccionarBusquedaGrupotratamiento(tratamiento) {
      this.datosTablalstTratamientosGrupoDescuento = [];
      if (tratamiento == null) {
        this.datosTablalstTratamientosGrupoDescuento =
            this.lstGruposTratamientos;
      } else {
        this.lstGruposTratamientos.forEach((element) => {
          element.tratamientoGrupoTratamientoDTOS.forEach((datos) => {
            if (datos.idTratamiento == tratamiento.idTratamiento) {
              this.datosTablalstTratamientosGrupoDescuento.push(element);
            }
          });
        });
      }
    },

    buscarPacientes() {

      if (this.validarInputBusqueda()) {
        console.error("No se puede buscar por validacion de numeros letras")
        return;
      }

      if (this.loadingPacientes) {
        return;
      }

      this.registros = Array();
      if (
          this.nombrePacienteBusqueda === undefined ||
          this.nombrePacienteBusqueda === null ||
          this.nombrePacienteBusqueda.length < 4
      ) {
        return;
      }

      const inputTxt = this.nombrePacienteBusqueda
          .trim()
          .toUpperCase();

      this.loadingPacientes = true;
      this.mostrarBarraBusqueda = true;
      const parametros = {
        idPaciente: /[0-9]/.test(this.nombrePacienteBusqueda) ? inputTxt : null, nombrePaciente: /[0-9]/.test(this.nombrePacienteBusqueda) ? null : inputTxt,
        idPlan: this.empresaActual.idPlan,
        paginaActual: this.paginaActual - 1,
      }
      this.listaPacientes = [];
      this.listaTotalPacientes = 0;
      if(parametros.idPaciente == null){
        this.$http.post(this.$api +"planPaciente/obtener/pacientesTotal", parametros).then((response) => {
          if (response.status === 200) {
            this.listaTotalPacientes = response.data.data;
            this.busquedaRealizada = true;
          }
        }).catch((error) => {
          miniToastr.info("No se encontraron pacientes");
          console.error("Error", error);
          this.loadingPacientes = false;
        }).finally(() => {
          this.$http.post(this.$api +"planPaciente/obtener/pacientes", parametros).then((response) => {
            if (response.status === 200) {
              this.listaPacientes = response.data.data;
              this.busquedaRealizada = true;
            }
          }).catch((error) => {
            miniToastr.info("No se encontraron pacientes");
            console.error("Error", error);
            this.loadingPacientes = false;
          }).finally(() => {
            this.loadingPacientes = false;
          });
        });
      }else{
        this.$http.post(this.$api +"planPaciente/obtener/pacientes", parametros).then((response) => {
          if (response.status === 200) {
            this.listaPacientes = response.data.data;
            this.busquedaRealizada = true;
          }
        }).catch((error) => {
          miniToastr.info("No se encontraron pacientes");
          console.error("Error", error);
          this.loadingPacientes = false;
        }).finally(() => {
          this.loadingPacientes = false;
        });
      }
    },

    async cancelarBuscar() {
      this.mostrarBarraBusqueda = false;
    },

    validarInputBusqueda() {
      if (this.nombrePacienteBusqueda !== undefined
          && this.nombrePacienteBusqueda !== null
          && this.nombrePacienteBusqueda !== '') {

        const contieneNumerosLetras =  /[A-Za-z]/.test(this.nombrePacienteBusqueda);
        const contieneNumeros = /[0-9]/.test(this.nombrePacienteBusqueda);
        return contieneNumerosLetras && contieneNumeros;
      }

      return false;
    },

    enviarPerfilPaciente(idPaciente){
      this.$router.push({name: "paciente", params: {id: idPaciente}})
    },
  },
};
</script>

<style scoped>
.scrollable-container-catalogo {
  overflow-y: auto;
  max-height: 40em;
}

</style>